import { languageSchema } from "./languageSchema.js";
import { makeI18nField } from "../utils/i18nSchemas.js";

function makeAnnouncementBase(extraProps = {}, required = []) {
  return {
    type: "object",
    properties: {
      titleI18n: makeI18nField({ required: true, minLength: 1 }),
      textI18n: makeI18nField(),
      type: { type: "string", enum: ["info", "warning"] },
      isVisible: { type: "boolean" },
      image: { type: "string" },
      targetedTagIds: {
        type: ["array", "null"],
        items: { type: "number" },
      },
      scheduledAt: { type: "string", format: "date-time", nullable: true },
      shouldAutoNotify: { type: "boolean" },
      linkType: {
        type: ["string", "null"],
        enum: [
          "documents",
          "agenda",
          "session",
          "speaker",
          "sponsor",
          "page",
          "myProfile",
          null,
        ],
      },
      linkTargetId: { type: ["number", "null"] },
      ...extraProps,
    },
    additionalProperties: false,
    required,
  };
}

const web_linkProps = {
  linkType: { type: "string" },
  linkTargetId: { type: ["string", "null"] },
};

const web_requireLinkTarget = {
  if: {
    properties: {
      linkType: { enum: ["session", "speaker", "sponsor", "page"] },
    },
    required: ["linkType"],
  },
  then: { properties: { linkTargetId: { type: "string", minLength: 1 } } },
};

export const createAnnouncementSchema = {
  body: makeAnnouncementBase(
    {
      eventId: { type: "number" },
      isOnlyThisVisible: { type: "boolean" },
    },
    ["eventId", "type", "titleI18n", "textI18n"]
  ),
};

export const patchAnnouncementSchema = {
  body: makeAnnouncementBase({ isOnlyThisVisible: { type: "boolean" } }),
};

export const web_patchAnnouncementSchema = {
  ...makeAnnouncementBase(
    {
      isVisible: { type: "string", enum: ["true", "false"] },
      targetedTagIds: { type: ["array", "null"], items: { type: "string" } },
      scheduledAt: { type: ["string", "null"] },
      shouldAutoNotify: { type: ["string", "null"] },
      ...web_linkProps,
    },
    ["isVisible"]
  ),
  ...web_requireLinkTarget,
};

export const createSpecialInvitationSchema = {
  body: makeAnnouncementBase({ eventId: { type: "number" } }, [
    "eventId",
    "image",
    "titleI18n",
  ]),
};

export const patchSpecialInvitationSchema = {
  body: makeAnnouncementBase(),
};

export const web_createAnnouncementSchema = {
  ...makeAnnouncementBase(
    {
      eventId: { type: "number" },
      isVisible: { type: "string", enum: ["true", "false"] },
      targetedTagIds: { type: ["array", "null"], items: { type: "string" } },
      scheduledAt: { type: ["string", "null"] },
      shouldAutoNotify: { type: ["string", "null"] },
      ...web_linkProps,
    },
    ["isVisible", "titleI18n"]
  ),
  ...web_requireLinkTarget,
};

export const web_specialInvitationSchema = {
  type: "object",
  properties: {
    titleI18n: makeI18nField({ required: true, minLength: 1 }),
    image: { type: ["string", "null"] },
    isVisible: { type: "string", enum: ["true", "false"] },
    eventId: { type: "number" },
    targetedTagIds: { type: ["array", "null"], items: { type: "string" } },
  },
  required: ["eventId", "titleI18n"],
  additionalProperties: false,
};

export const getAnnouncementsSchema = {
  querystring: {
    type: "object",
    properties: {
      eventId: { type: "number" },
      page: { type: "number" },
      limit: { type: "number" },
      getAll: { type: "boolean" },
      type: {
        type: "string",
        enum: ["info", "warning", "special", "info,warning"],
      },
      ...languageSchema.properties,
    },
    required: ["eventId"],
  },
};

export const getAnnouncementByIdSchema = {
  querystring: languageSchema,
  params: {
    type: "object",
    properties: { id: { type: "number" } },
    required: ["id"],
  },
};

export const deleteAnnouncementSchema = {
  body: {
    type: "object",
    properties: { id: { type: "number" } },
    required: ["id"],
  },
};

export const createAnnouncementNotifySchema = {
  body: {
    type: "object",
    properties: { announcementId: { type: "string" } },
    required: ["announcementId"],
  },
};
